import { filterOutUnavailableDeliveryInfo } from '@epicuro-next/features/engagement/list-utils';
import { memoize } from '@epicuro-next/utilities';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { mapProductReferencesToListProductEntity } from '../utils';

import { LIST_PRODUCT_REFERENCE_ENTITIES_STATE_KEY } from './constants';
import { State } from './list-product-reference-entities.adapter';

export const selectListProductReferenceState = createFeatureSelector<State>(
  LIST_PRODUCT_REFERENCE_ENTITIES_STATE_KEY,
);

export const selectCommercialListProductReferencesFactory = memoize(
  (id: string) =>
    createSelector(
      selectListProductReferenceState,
      (state) => state.entities[id],
    ),
);

export const selectAvailableProductDeliveryInfo = memoize((id: string) =>
  createSelector(selectCommercialListProductReferencesFactory(id), (entity) => {
    if (!entity || !entity.data || !entity.data.productReferences) {
      return undefined;
    }

    const availableProducts = filterOutUnavailableDeliveryInfo(
      entity?.data?.productReferences,
    );

    return mapProductReferencesToListProductEntity(
      id,
      entity.data.currency,
      availableProducts,
    );
  }),
);
